export function readProductCatalogTableSettings(
  storageKey,
  columns,
  { migrateVisibleColumnKeys = () => [] } = {},
) {
  const columnKeys = columns.map(({ key }) => key);
  const defaults = {
    columnOrder: columnKeys,
    visibleColumnKeys: columnKeys,
    columnFilters: {},
    sortConfig: { key: "Model", direction: "asc" },
  };

  try {
    const stored = JSON.parse(window.localStorage.getItem(storageKey));
    if (!stored || typeof stored !== "object" || Array.isArray(stored)) {
      return defaults;
    }

    const normalizeColumnKeys = (keys) => {
      if (!Array.isArray(keys)) return null;
      const validKeys = [
        ...new Set(keys.filter((key) => columnKeys.includes(key))),
      ];
      return [
        ...validKeys,
        ...columnKeys.filter((key) => !validKeys.includes(key)),
      ];
    };
    const storedVisibleKeys = Array.isArray(stored.visibleColumnKeys)
      ? stored.visibleColumnKeys.filter((key) => columnKeys.includes(key))
      : defaults.visibleColumnKeys;
    const migratedVisibleKeys = migrateVisibleColumnKeys(stored).filter((key) =>
      columnKeys.includes(key),
    );
    const sortConfig =
      stored.sortConfig &&
      columnKeys.includes(stored.sortConfig.key) &&
      ["asc", "desc"].includes(stored.sortConfig.direction)
        ? stored.sortConfig
        : defaults.sortConfig;

    return {
      columnOrder:
        normalizeColumnKeys(stored.columnOrder) || defaults.columnOrder,
      visibleColumnKeys: [
        ...new Set([
          ...(columnKeys.includes("Model") ? ["Model"] : []),
          ...storedVisibleKeys,
          ...migratedVisibleKeys,
        ]),
      ],
      columnFilters:
        stored.columnFilters &&
        typeof stored.columnFilters === "object" &&
        !Array.isArray(stored.columnFilters)
          ? stored.columnFilters
          : defaults.columnFilters,
      sortConfig,
    };
  } catch {
    return defaults;
  }
}
